import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoSidebar16 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M12.5 1.75C13.6798 1.75 14.7498 2.64146 14.75 3.875V12.125C14.75 13.3587 13.6799 14.25 12.5 14.25H3.5C2.32013 14.25 1.25 13.3587 1.25 12.125V3.875C1.25018 2.64146 2.32022 1.75 3.5 1.75H12.5ZM3.5 3.25C3.02319 3.25 2.75019 3.58998 2.75 3.875V12.125C2.75 12.4101 3.02301 12.75 3.5 12.75H12.5C12.977 12.75 13.25 12.4101 13.25 12.125V3.875C13.2498 3.58997 12.9768 3.25 12.5 3.25H3.5ZM11.75 4C12.1642 4 12.5 4.33579 12.5 4.75V11.25C12.5 11.6642 12.1642 12 11.75 12H9.25C8.83579 12 8.5 11.6642 8.5 11.25V4.75C8.5 4.33579 8.83579 4 9.25 4H11.75Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoSidebar16;